import { render } from "./SelectorCaducidad.vue?vue&type=template&id=4f577980&scoped=true"
import script from "./SelectorCaducidad.vue?vue&type=script&lang=js"
export * from "./SelectorCaducidad.vue?vue&type=script&lang=js"

import "./SelectorCaducidad.vue?vue&type=style&index=0&id=4f577980&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f577980"]])

export default __exports__